export type ConsentValue = "granted" | "denied" | null;

const KEY = "cookie-consent";
const EVENT = "cookie-consent-change";

export const getConsent = (): ConsentValue => {
  if (typeof window === "undefined") return null;
  const v = window.localStorage.getItem(KEY);
  return v === "granted" || v === "denied" ? v : null;
};

export const setConsent = (value: "granted" | "denied") => {
  window.localStorage.setItem(KEY, value);
  window.dispatchEvent(new CustomEvent(EVENT, { detail: value }));
};

export const clearConsent = () => {
  window.localStorage.removeItem(KEY);
  window.dispatchEvent(new CustomEvent(EVENT, { detail: null }));
};

export const onConsentChange = (cb: (v: ConsentValue) => void) => {
  const handler = (e: Event) => cb((e as CustomEvent).detail as ConsentValue);
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
};
